<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaTipoAtendimentos"
        title-table="Tipos de Atendimento"
        module="tipoAtendimentoSettingsModule"
        sort-name="descricao"
        :add-permission="'ROLE_TIPO_ATENDIMENTO_INSERIR'"
        :view-permission="'ROLE_TIPO_ATENDIMENTO_CONSULTAR'"
        :edit-permission="'ROLE_TIPO_ATENDIMENTO_ATUALIZAR'"
        :delete-permission="'ROLE_TIPO_ATENDIMENTO_DELETAR'"
        :search-field="'descricao'"
        @add="addNew"
        @edit="edit"
      />
      <FormTipoAtendimento
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import FormTipoAtendimento from './forms/FormTipoAtendimento.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormTipoAtendimento,
  },

  computed: {
    ...mapState('tipoAtendimentoSettingsModule', {
      listaTipoAtendimentos: state => state.listaTipoAtendimentos,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id',
        },
        {
          label: 'Descrição',
          field: 'descricao',
        },
        {
          label: 'Ativo',
          field: 'ativo',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.$store.dispatch('tipoAtendimentoSettingsModule/resetTipoAtendimento')
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch(
        'tipoAtendimentoSettingsModule/prepareToEditTipoAtendimento',
        data,
      )
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
